import {
    AfterViewInit,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
    ViewChild
} from "@angular/core";
import {IAnalysisPackage} from "../irb-rebalance.model";
import {RebalanceService} from "../rebalance.service";
import {DatePipe} from "@angular/common";
import {IRebalanceTypeItem} from "@irb/irb-create-rebalance/irb-create-rebalance.service";
import {FormControl} from "@angular/forms";
import {AppService} from "@irb/app.service";
import {DropdownFilterComponent} from "@irb/irb-common/components/dropdown-filter/dropdown-filter.component";
import {IDropdownItem} from "@irb/irb-common/models/dropdown.model";
import {IrbEditorsEvents} from "@irb/irb-editors/irb-editors.events";
import {EditorModelService} from "@irb/irb-editors/editor-model/editor-model.service";

@Component({ standalone: false,
    selector: "rebalance-general-info",
    templateUrl: "./rebalance-general-info.component.html",
    styleUrls: ["./rebalance-general-info.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager
})
export class RebalanceGeneralInfoComponent implements OnInit, OnDestroy, AfterViewInit {
    @ViewChild('IrbSelectedRebalanceTypeDropdown') selectReference: DropdownFilterComponent;
    @ViewChild("analysisNameField") analysisNameField: any;
    @ViewChild("tradeExplnField") tradeExplnField: any;
    @Input() ignoreUnsavedChanges: boolean = false;
    @Output() change = new EventEmitter<any>();

    _data: IAnalysisPackage;
    _isReadOnly:boolean=false;
    analysisTypeDropdown: boolean = false;
    rebalInfo: string;
    _rebalanceTypeLists: IDropdownItem[];
    selectedRebalanceType: any = new FormControl({value: '', disabled: !this.analysisTypeDropdown});
    navigationSource:any;
    rebalanceTypeDisabled: boolean = false;
    private isTLHSetInGlobal = true;
    isTlhWsaEnabled: boolean = false;

    constructor(private cdr: ChangeDetectorRef,
        //private readonly rebalanceService: RebalanceService,
        private as: AppService,
        private rs: RebalanceService,
        private editorModelService: EditorModelService,
        public datePipe: DatePipe) {
    }
    
    ngOnInit(): void {
        const globSet: any = this.editorModelService.getGlobalSettings();
        if (globSet)
            this.isTLHSetInGlobal = globSet.isTlhLotLevel || globSet.isTlhPositionLevel;

        if (this._data) {
            this.navigationSource = this._data.navigationSource;
        }
        this.load();

        const rebsrc: string = this.rs.getRebalanceSource();
        this.rebalanceTypeDisabled = (rebsrc === 'resultSummary' || rebsrc === 'Scheduled');
        // this.rebalanceService.setRebalanceSource(null);

        const config = this.as.getItem('IRB_APP_CONFIG');
        if (config) {
            this.isTlhWsaEnabled = config.isTlhWsaEnabled;
        }
    }
    ngAfterViewInit() {
        this.selectReference?.input?.nativeElement?.focus();
        const s = typeof this.selectReference?.inputControl?.value === "string" ? this.selectReference?.inputControl?.value : "";
        this.selectReference?.input?.nativeElement?.setSelectionRange(0, s.length);
        // this.selectReference?.focusInput();
    }
    ngOnDestroy(): void {
    }

    load() {
        const rebalanceTypeArr = this.rs.getRebalanceTypeListObject(this.as.getItem('IRB_APP_CONFIG')?.isTlhWsaEnabled);
        if (this.isTLHSetInGlobal) {
            rebalanceTypeArr.forEach((rebType: any) => {
                if (rebType.gvalue === 'TLH_FULL_REBALANCE') {
                    delete rebType.customToolTipWhenDisabled;
                }
            })
        }
        if (this.data.analysisId !== null && this.data.analysisId !== undefined) {
            this.rebalanceTypeLists = rebalanceTypeArr.map(this.mapRebalanceType);
            if (this.data.scheduler === null || this.data.scheduler === undefined) {
                if (this.isReadOnly) {
                    if (this.data.isSysSuggestion || !this.data.analysisName) {
                        this.populateAnalysisName();
                    }
                    this.analysisTypeDropdown = false;
                }
                this.populateRebalType();
            } else {
                // this.rebalanceTypeLists = rebalanceTypeArr.map(this.mapRebalanceType);
                if (this.isReadOnly) {
                    this.analysisTypeDropdown = false;
                }
                this.populateRebalType();
            }
                
        }else{
            this.rebalanceTypeLists = rebalanceTypeArr.map(this.mapRebalanceType);
            if (!this.isReadOnly) {
                if (this.data.isSysSuggestion || !this.data.analysisName) {
                    this.populateAnalysisName();
                }
                this.analysisTypeDropdown = true;
            }
            this.populateRebalType();
        }
 
        (this.analysisTypeDropdown) ? this.selectedRebalanceType.enable() : this.selectedRebalanceType.disable();
    }

    mapRebalanceType(rebalanceType: IRebalanceTypeItem): IDropdownItem {
        let rebItem: any = {name: rebalanceType.label, value: rebalanceType};
        if (rebalanceType.customToolTipWhenDisabled) {
            rebItem.customToolTipWhenDisabled = rebalanceType.customToolTipWhenDisabled;
            rebItem.class = 'grid-cell-disabled';
            rebItem.notClickableItem = true;
        }
        return rebItem;
    }

    setChainTypeOptions(searchStr: any) {
        const f = DropdownFilterComponent.getFilteredList(searchStr, this.rebalanceTypeLists);
        this.selectReference.set(f);
    }
    
    selectOption(event: IDropdownItem) {
        if (this.selectedRebalanceType.value.name !== event.name) {
            this.selectedRebalanceType.setValue(event);
            this.switchRebalance();
        }
    }

    onGeneralInfoChange() {
        this.change.emit(true);
    }

    useSuggestedAnalysisName() {
        if (this.data.isSysSuggestion) {
            this.populateAnalysisName();
        }
        this.onGeneralInfoChange();
        this.cdr.detectChanges()
    }

    populateRebalType() {
        for (let i = 0; i < this.rebalanceTypeLists.length; i++) {
            let rebalType: IDropdownItem = this.rebalanceTypeLists[i];
            if (this.data.analysisType === rebalType.name) {
                this.selectedRebalanceType.setValue(rebalType);
                break;
            }
        }
    }

    populateAnalysisName() {
        let todayDate = this.datePipe.transform(new Date(), "MM/dd/yyyy");
        if(this.data.analysisType) {
          //  this.data.isSysSuggestion = true;
            switch(this.data.analysisType) {
                case 'Full rebalance':
                    this.data.analysisName = "Full Reb - "+todayDate;
                    break;
                case 'Generate and/or invest cash':
                    this.data.analysisName = "Cash to Target - "+todayDate;
                    break;
                case 'Generate cash only':
                    this.data.analysisName = "Gen Cash - "+todayDate;
                    break;
                case 'Invest cash only':
                    this.data.analysisName = "Invest Cash - "+todayDate;
                    break;
                case 'Adjust securities':
                    this.data.analysisName = "Adj Securities - "+todayDate;
                    if(this.data.isNew){
                        // this.data.isUIAllPort == false;
                        this.data.adjustSecDto.adjustMultipleSecurities = [];
                    }
                    break;
                case 'Tax Loss Harvest':
                    this.data.analysisName = "Harvest - "+todayDate;
                    if(this.data.isNew){
                    // this.data.isUIAllPort == false;
                    this.data.harvestTaxLossDto.htlSecsdtoList = [];
                    }
                    break;
                case 'Replace securities':
                    this.data.analysisName = "Replace - "+todayDate;
                    if(this.data.isNew){
                    // this.data.isUIAllPort == false;
                    this.data.replaceSecsDto.replaceMultipleSecurities = null;
                    }
                    break;
                case 'Manual adjustment':
                    this.data.analysisName = "Manual Adj - "+todayDate;
                    break;
                case 'Covered call':
                    this.data.analysisName = "Covered Call - "+todayDate;
                    if (this.data.coveredCallDTO) {
                        this.data.coveredCallDTO.action = this.data.isNew ? 'SELL_COVER_CALL' : this.data.coveredCallDTO.action;
                    }
                    break;
            }
        }
    }

    switchRebalance() {
        const self = this;
        const params = {
            fullscreen: true,
            ignoreUnsavedChanges: true,
            data: {
                analysisType: this.selectedRebalanceType.value.name,
                navigationSource  : this.navigationSource
            },
            rebalanceParams: self.data
          };
        this.change.emit(true);
        this.rs.getRebalanceTypeEvent(params);
    }

    @Input()
    get data() {
        return this._data;
    }

    set data(data: IAnalysisPackage) {
        this._data = data;
    }

    @Input()
    get isReadOnly() {
        return this._isReadOnly;
    }

    set isReadOnly(isReadOnly: boolean) {
        this._isReadOnly = isReadOnly;
    }

    get rebalanceTypeLists() {
        return this._rebalanceTypeLists; 
    }

    set rebalanceTypeLists(rebalanceTypeLists: IDropdownItem[]) {
        this._rebalanceTypeLists = rebalanceTypeLists;
    }


    showRebalanceTypeInfo() {
        const passData: any = {
            rebalanceTypeObject: this.selectedRebalanceType.value,
            isTLHSetInGlobal: this.isTlhWsaEnabled ? this.isTLHSetInGlobal ? true : false : false
        }
        this.as.fireEvent(IrbEditorsEvents.SHOW_REBALANCE_TYPE_INFO_DIALOG, passData);
    }
}
